import React, { useEffect, useState, useRef } from "react";
import "./PhotoGallery.css";
import { baseURl } from "../../config";
import GalleryDetail from "./GalleryDetail";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ModernGallery = () => {
  const scrollRef = useRef(null);
  const [data, setData] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const navigate = useNavigate();
  const { gallery } = useSelector((state) => state.data);
  useEffect(() => {
    const groupedData = groupByType(gallery);
    setData(groupedData);

    const interval = setInterval(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft += 1000;
        if (
          scrollRef.current.scrollLeft + scrollRef.current.clientWidth >=
          scrollRef.current.scrollWidth
        ) {
          scrollRef.current.scrollLeft = 0;
        }
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const groupByType = (images) => {
    const grouped = {};
    images.forEach((image) => {
      if (!grouped[image.typeSlug]) {
        grouped[image.typeSlug] = {
          type: image.type,
          typeSlug: image.typeSlug,
          images: [],
        };
      }
      grouped[image.typeSlug].images.push(image);
    });

    return Object.values(grouped).map((group) => ({
      ...group,
      randomImage: group.images[0], // Picks random image
    }));
  };

  return (

    <div className="gallery-section441">
        
        <div className={`gallery-container ${data.length < 3 ? "few-items" : ""}`} ref={scrollRef}>
        {data.map((item, index) => (
          <div key={index} className="gallery-item" onClick={() => navigate(`/gallery/${item.typeSlug}`)}>
            <div className="image-wrapper">
              <img
                src={`${baseURl}/${item.randomImage.galleryImage}`}
                alt={item.randomImage.heading}
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              />
              {!item.randomImage.typeSlug.includes('akinex') &&
                <div className="image-overlay">
                  <div className="image-title">{item.randomImage.type}</div>
                </div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModernGallery;
